import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/current-cardiological-state/hospitalizations";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hospitalizations: {
		id: "form.hospitalizations",
		defaultMessage: "HF hospitalizáció"
	},
	value: {
		id: "form.hospitalizations.value",
		defaultMessage: "Szívelégtelenség hospitalizációk száma (1 éven belül)"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "hospitalizations",
	value: {
		title: messages.hospitalizations,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
